import styled from '@emotion/styled'
import { hexColors } from '@mobi/settings'
import { spacing, font } from '@mobi/component-library/Theme/Common'

export const ContainerStyled = styled.div({
  display: 'flex',
  flexGrow: 1,
  padding: `${spacing.smx1} ${spacing.md} ${spacing.md} ${spacing.md}`,
  marginTop: '2rem',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '2rem',
  //  background: colors.white,
})

export const TitleStyled = styled.div({
  textAlign: 'center',
  fontFamily: font.family.primary,
  fontSize: font.size.lg.fontSize,
  fontStyle: 'normal',
  fontWeight: font.weight.semibold,
  lineHeight: '2rem',
  color: hexColors.black,
})

export const MessageStyled = styled(TitleStyled)({
  fontWeight: font.weight.regular,
  width: '252px',
})
